import { type HttpInterceptor, type HttpRequest, type HttpHandler, type HttpEvent } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { type Observable, catchError, switchMap } from 'rxjs'
import { KcAuthService } from '../services/kc-auth.service'
import { ImpersonateUserService } from '../services/impersonate-user.service'

@Injectable()
export class RefreshTokenInterceptor implements HttpInterceptor {
  constructor (
    private readonly kcAuthService: KcAuthService,
    private readonly impersonateUserService: ImpersonateUserService
  ) {}

  intercept (request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return this.impersonateUserService.isUserImpersonated().pipe(
      switchMap(isUserImpersonated => {
        if (isUserImpersonated) {
          return null
        }

        return this.kcAuthService.handleTrackTokenRefresh()
      }),
      switchMap((token) => {
        if (token !== null && token !== undefined) {
          const modifiedReq = request.clone({
            setHeaders: { 'X-Auth-Token': token }
          })
          return next.handle(modifiedReq)
        }
        return next.handle(request)
      }),
      catchError(() => {
        return next.handle(request)
      })
    )
  }
}
